// extracted by mini-css-extract-plugin
module.exports = {"flex":"Title_flex__VPPO5","title":"Title_title__eZq08","num":"Title_num__3bWHz","container":"Title_container__1WYDt","time":"Title_time__i6GZf"};